import React from "react";

import { CampaignStatusesTableActions } from "./CampaignStatusesTableActions";

export const getCampaignStatusesTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      width: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CampaignStatusesTableActions original={row.original} />
      ),
    },
  ];
};
